import React from 'react'

export const Footer = () => {
  return (
 <footer className="footer_wrap footer_custom footer_custom_18721 footer_custom_footer-main												">
        <div
          data-elementor-type="cpt_layouts"
          data-elementor-id={18721}
          className="elementor elementor-18721"
        >
          <section
            className="elementor-section elementor-top-section elementor-element elementor-element-3eeccb12 elementor-section-boxed elementor-section-height-default elementor-section-height-default sc_fly_static"
            data-id="3eeccb12"
            data-element_type="section"
            data-settings='{"background_background":"classic"}'
          >
            <div className="elementor-container elementor-column-gap-extended">
              <div
                className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-bedaac3 sc_content_align_inherit sc_layouts_column_icons_position_left sc_fly_static"
                data-id="bedaac3"
                data-element_type="column"
              >
                <div className="elementor-widget-wrap elementor-element-populated">
                  <div
                    className="sc_layouts_item elementor-element elementor-element-62311765 sc_height_large sc_fly_static elementor-widget elementor-widget-spacer"
                    data-id={62311765}
                    data-element_type="widget"
                    data-widget_type="spacer.default"
                  >
                    <div className="elementor-widget-container">
                      <div className="elementor-spacer">
                        <div className="elementor-spacer-inner" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section
            className="elementor-section elementor-top-section elementor-element elementor-element-6f399fac sc_layouts_row sc_layouts_row_type_compact scheme_dark elementor-section-boxed elementor-section-height-default elementor-section-height-default sc_fly_static"
            data-id="6f399fac"
            data-element_type="section"
            data-settings='{"background_background":"classic"}'
          >
            <div className="elementor-container elementor-column-gap-extended">
              <div
                className="elementor-column elementor-col-25 elementor-top-column elementor-element elementor-element-7bcd4832 sc_content_align_inherit sc_layouts_column_icons_position_left sc_fly_static"
                data-id="7bcd4832"
                data-element_type="column"
              >
                <div className="elementor-widget-wrap elementor-element-populated">
                  <div
                    className="sc_layouts_item elementor-element elementor-element-60bdbfdb sc_fly_static elementor-widget elementor-widget-trx_sc_title"
                    data-id="60bdbfdb"
                    data-element_type="widget"
                    data-widget_type="trx_sc_title.default"
                  >
                    <div className="elementor-widget-container">
                      <div className="sc_title sc_title_default">
                        <h6 className="sc_item_title sc_title_title sc_item_title_style_default sc_item_title_tag">
                          <span className="sc_item_title_text">
                            Hello, We Are Golden Agriculture
                          </span>
                        </h6>
                      </div>
                    </div>
                  </div>
                  <div
                    className="sc_layouts_item elementor-element elementor-element-ecaf94 sc_fly_static elementor-widget elementor-widget-spacer"
                    data-id="ecaf94"
                    data-element_type="widget"
                    data-widget_type="spacer.default"
                  >
                    <div className="elementor-widget-container">
                      <div className="elementor-spacer">
                        <div className="elementor-spacer-inner" />
                      </div>
                    </div>
                  </div>
                  <div
                    className="sc_layouts_item elementor-element elementor-element-63726f0f sc_fly_static elementor-widget elementor-widget-text-editor"
                    data-id="63726f0f"
                    data-element_type="widget"
                    data-widget_type="text-editor.default"
                  >
                    <div className="elementor-widget-container">
                      Building food stability through consistent sourcing and dependable trade.{" "}
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="elementor-column elementor-col-25 elementor-top-column elementor-element elementor-element-1a8893ce sc_content_align_inherit sc_layouts_column_icons_position_left sc_fly_static"
                data-id="1a8893ce"
                data-element_type="column"
              >
                <div className="elementor-widget-wrap elementor-element-populated">
                  <div
                    className="sc_layouts_item elementor-element elementor-element-4790c85d sc_fly_static elementor-widget elementor-widget-trx_sc_title"
                    data-id="4790c85d"
                    data-element_type="widget"
                    data-widget_type="trx_sc_title.default"
                  >
                    <div className="elementor-widget-container">
                      <div className="sc_title sc_title_default">
                        <h6 className="sc_item_title sc_title_title sc_item_title_style_default sc_item_title_tag">
                          <span className="sc_item_title_text">Office</span>
                        </h6>
                      </div>
                    </div>
                  </div>
                  <div
                    className="sc_layouts_item elementor-element elementor-element-31d034b3 sc_fly_static elementor-widget elementor-widget-spacer"
                    data-id="31d034b3"
                    data-element_type="widget"
                    data-widget_type="spacer.default"
                  >
                    <div className="elementor-widget-container">
                      <div className="elementor-spacer">
                        <div className="elementor-spacer-inner" />
                      </div>
                    </div>
                  </div>
                  <div
                    className="sc_layouts_item elementor-element elementor-element-79f2fcea sc_fly_static elementor-widget elementor-widget-text-editor"
                    data-id="79f2fcea"
                    data-element_type="widget"
                    data-widget_type="text-editor.default"
                  >
                    <div className="elementor-widget-container">
                      <p>
                        Head Office —<br />
                        Golden Agriculture Company
                        Muscat, Sultanate of Oman
                        <br />
                        {/* , De 81566 */}
                      </p>
                    </div>
                  </div>
                  <div
                    className="sc_layouts_item elementor-element elementor-element-59ea2916 sc_layouts_hide_on_mobile sc_fly_static elementor-widget elementor-widget-spacer"
                    data-id="59ea2916"
                    data-element_type="widget"
                    data-widget_type="spacer.default"
                  >
                    <div className="elementor-widget-container">
                      <div className="elementor-spacer">
                        <div className="elementor-spacer-inner" />
                      </div>
                    </div>
                  </div>
                  <div
                    className="sc_layouts_item elementor-element elementor-element-1efd37c4 sc_fly_static elementor-widget elementor-widget-text-editor"
                    data-id="1efd37c4"
                    data-element_type="widget"
                    data-widget_type="text-editor.default"
                  >
                    <div className="elementor-widget-container">
                      <p>
                        <a
                          className="underline_anim"
                          href="https://mail.google.com/mail/?view=cm&fs=1&to=info@gmail.com"
                        >
                          <span
                            className="__cf_email__ underline_anim underline_do_hover"
                            data-cfemail="e1888f878ea1848c80888dcf828e8c"
                          >
                           info@goldenagriculturecompany.com
                          </span>
                        </a>
                      </p>
                    </div>
                  </div>
                  <div
                    className="sc_layouts_item elementor-element elementor-element-29ae1af sc_layouts_hide_on_mobile sc_fly_static elementor-widget elementor-widget-spacer"
                    data-id="29ae1af"
                    data-element_type="widget"
                    data-widget_type="spacer.default"
                  >
                    <div className="elementor-widget-container">
                      <div className="elementor-spacer">
                        <div className="elementor-spacer-inner" />
                      </div>
                    </div>
                  </div>
                  <div
                    className="sc_layouts_item elementor-element elementor-element-2fa47cd0 sc_fly_static elementor-widget elementor-widget-text-editor"
                    data-id="2fa47cd0"
                    data-element_type="widget"
                    data-widget_type="text-editor.default"
                  >
                    <div className="elementor-widget-container">
                      <span className="trx_addons_alter_text">
                        <a href="tel:+18408412569">+968 24 692 223</a>
                      </span>{" "}
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="elementor-column elementor-col-25 elementor-top-column elementor-element elementor-element-21a26976 sc_content_align_inherit sc_layouts_column_icons_position_left sc_fly_static"
                data-id="21a26976"
                data-element_type="column"
              >
                <div className="elementor-widget-wrap elementor-element-populated">
                  <div
                    className="sc_layouts_item elementor-element elementor-element-60a37f29 sc_fly_static elementor-widget elementor-widget-trx_sc_title"
                    data-id="60a37f29"
                    data-element_type="widget"
                    data-widget_type="trx_sc_title.default"
                  >
                    <div className="elementor-widget-container">
                      <div className="sc_title sc_title_default">
                        <h6 className="sc_item_title sc_title_title sc_item_title_style_default sc_item_title_tag">
                          <span className="sc_item_title_text">Links</span>
                        </h6>
                      </div>
                    </div>
                  </div>
                  <div
                    className="sc_layouts_item elementor-element elementor-element-746673c2 sc_fly_static elementor-widget elementor-widget-spacer"
                    data-id="746673c2"
                    data-element_type="widget"
                    data-widget_type="spacer.default"
                  >
                    <div className="elementor-widget-container">
                      <div className="elementor-spacer">
                        <div className="elementor-spacer-inner" />
                      </div>
                    </div>
                  </div>
                  <div
                    className="sc_layouts_item elementor-element elementor-element-4166911b sc_fly_static elementor-widget elementor-widget-trx_widget_custom_links"
                    data-id="4166911b"
                    data-element_type="widget"
                    data-widget_type="trx_widget_custom_links.default"
                  >
                    <div className="elementor-widget-container">
                      <div className="widget_area sc_widget_custom_links">
                        <aside className="widget widget_custom_links">
                          <ul className="custom_links_list">
                            <li className="custom_links_list_item">
                              <a
                                className="custom_links_list_item_link"
                                href="/"
                              >
                                <span className="custom_links_list_item_title">
                                  Home
                                </span>
                              </a>
                            </li>
                                         <li className="custom_links_list_item">
                              <a
                                className="custom_links_list_item_link"
                                href="/about-us"
                              >
                                <span className="custom_links_list_item_title">
                                  About
                                </span>
                              </a>
                            </li>
                            <li className="custom_links_list_item">
                              <a
                                className="custom_links_list_item_link"
                                href="/services"
                              >
                                <span className="custom_links_list_item_title">
                                  Services
                                </span>
                              </a>
                            </li>
               
                            <li className="custom_links_list_item">
                              <a
                                className="custom_links_list_item_link"
                                href="/blog"
                              >
                                <span className="custom_links_list_item_title">
                                  Blog
                                </span>
                              </a>
                            </li>
                            <li className="custom_links_list_item">
                              <a
                                className="custom_links_list_item_link"
                                href="/contacts"
                              >
                                <span className="custom_links_list_item_title">
                                  Contact Us
                                </span>
                              </a>
                            </li>
                          </ul>
                        </aside>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="elementor-column elementor-col-25 elementor-top-column elementor-element elementor-element-3c45ea6f sc_content_align_inherit sc_layouts_column_icons_position_left sc_fly_static"
                data-id="3c45ea6f"
                data-element_type="column"
              >
                <div className="elementor-widget-wrap elementor-element-populated">
                  <div
                    className="sc_layouts_item elementor-element elementor-element-682dcec3 sc_fly_static elementor-widget elementor-widget-trx_sc_title"
                    data-id="682dcec3"
                    data-element_type="widget"
                    data-widget_type="trx_sc_title.default"
                  >
                    <div className="elementor-widget-container">
                      <div className="sc_title sc_title_default">
                        <h6 className="sc_item_title sc_title_title sc_item_title_style_default sc_item_title_tag">
                          <span className="sc_item_title_text">
                            Get in Touch
                          </span>
                        </h6>
                      </div>
                    </div>
                  </div>
                  <div
                    className="sc_layouts_item elementor-element elementor-element-606426a8 sc_fly_static elementor-widget elementor-widget-trx_sc_socials"
                    data-id="606426a8"
                    data-element_type="widget"
                    data-widget_type="trx_sc_socials.default"
                  >
                    <div className="elementor-widget-container">
                      <div className="sc_socials sc_socials_icons_names sc_align_none">
                        <div className="socials_wrap sc_item_content">
                          <a
                            target="_blank"
                            href="https://www.facebook.com/profile.php?id=61578623335415"
                            className="social_item social_item_style_icons sc_icon_type_icons social_item_type_icons_names"
                          >
                            <span
                              className="social_icon social_icon_facebook-1"
                              style={{}}
                            >
                              {/* <span className="icon-facebook-1" /> */}
                              <i className="fa-brands fa-facebook-f"></i>

                            </span>
                            <span className="social_name social_facebook-1">
                              Facebook
                            </span>
                          </a>
                          <a
                            target="_blank"
                            href="https://www.linkedin.com/company/golden-agriculture-company/"
                            className="social_item social_item_style_icons sc_icon_type_icons social_item_type_icons_names"
                          >
                            <span
                              className="social_icon social_icon_twitter-new"
                              style={{}}
                            >
                            <i className="fa-brands fa-linkedin-in"></i>
                            </span>
                            <span className="social_name social_twitter-new">
                              LinkedIn
                            </span>
                          </a>
                          {/* <a
                            target="_blank"
                            href="https://dribbble.com/"
                            className="social_item social_item_style_icons sc_icon_type_icons social_item_type_icons_names"
                          >
                            <span
                              className="social_icon social_icon_dribble-new"
                              style={{}}
                            >
                            <i className="fa-brands fa-dribbble"></i>
                            </span>
                            <span className="social_name social_dribble-new">
                              Dribble
                            </span>
                          </a> */}
                          <a
                            target="_blank"
                            href="https://www.instagram.com/goldenagriculture___/"
                            className="social_item social_item_style_icons sc_icon_type_icons social_item_type_icons_names"
                          >
                            <span
                              className="social_icon social_icon_instagram"
                              style={{}}
                            >
                              <i className="fa-brands fa-instagram"></i>
                            </span>
                            <span className="social_name social_instagram">
                              Instagram
                            </span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section
            className="black_bg elementor-section elementor-top-section elementor-element elementor-element-6b3c2377 sc_layouts_row sc_layouts_row_type_compact scheme_dark elementor-section-boxed elementor-section-height-default elementor-section-height-default sc_fly_static"
            data-id="6b3c2377"
            data-element_type="section"
            data-settings='{"background_background":"classic"}'
          >
            <div className="elementor-container elementor-column-gap-extended" >
              <div
                className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-5f5f476d sc_content_align_inherit sc_layouts_column_icons_position_left sc_fly_static"
                data-id="5f5f476d"
                data-element_type="column"
              >
                <div className="elementor-widget-wrap elementor-element-populated">
                  <div
                    className="sc_layouts_item elementor-element elementor-element-7274466e sc_height_small sc_layouts_hide_on_mobile sc_fly_static elementor-widget elementor-widget-spacer"
                    data-id="7274466e"
                    data-element_type="widget"
                    data-widget_type="spacer.default"
                  >
                    <div className="elementor-widget-container">
                      <div className="elementor-spacer">
                        <div className="elementor-spacer-inner" />
                      </div>
                    </div>
                  </div>
                  <div
                    className="sc_layouts_item elementor-element elementor-element-6c49f957 sc_layouts_hide_on_wide sc_layouts_hide_on_desktop sc_layouts_hide_on_notebook sc_layouts_hide_on_tablet sc_fly_static elementor-widget elementor-widget-spacer"
                    data-id="6c49f957"
                    data-element_type="widget"
                    data-widget_type="spacer.default"
                  >
                    <div className="elementor-widget-container">
                      <div className="elementor-spacer">
                        <div className="elementor-spacer-inner" />
                      </div>
                    </div>
                  </div>
                  <div
                    className="sc_layouts_item elementor-element elementor-element-3033d4c3 elementor-widget-divider--view-line sc_fly_static elementor-widget elementor-widget-divider"
                    data-id="3033d4c3"
                    data-element_type="widget"
                    data-widget_type="divider.default"
                  >
                    <div className="elementor-widget-container">
                      <div className="elementor-divider">
                        <span className="elementor-divider-separator"></span>
                      </div>
                    </div>
                  </div>
                  <div
                    className="sc_layouts_item elementor-element elementor-element-77577327 sc_layouts_hide_on_mobile sc_fly_static elementor-widget elementor-widget-spacer"
                    data-id={77577327}
                    data-element_type="widget"
                    data-widget_type="spacer.default"
                  >
                    <div className="elementor-widget-container">
                      <div className="elementor-spacer">
                        <div className="elementor-spacer-inner" />
                      </div>
                    </div>
                  </div>
                  <div
                    className="sc_layouts_item elementor-element elementor-element-6d24adb3 sc_fly_static elementor-widget elementor-widget-text-editor"
                    data-id="6d24adb3"
                    data-element_type="widget"
                    data-widget_type="text-editor.default"
                  >
                    <div className="elementor-widget-container">
                      <a
                        href="/portfolio"
                        target="_blank"
                        rel="noopener"
                      >
                        Golden Agriculture
                      </a>{" "}
                      © 2025. All Rights Reserved.{" "}
                    </div>
                  </div>
                  <div
                    className="sc_layouts_item elementor-element elementor-element-7cc001c5 sc_fly_static elementor-widget elementor-widget-spacer"
                    data-id="7cc001c5"
                    data-element_type="widget"
                    data-widget_type="spacer.default"
                  >
                    <div className="elementor-widget-container">
                      <div className="elementor-spacer">
                        <div className="elementor-spacer-inner" />
                      </div>
                    </div>
                  </div>
                  <div
                    className="sc_layouts_item elementor-element elementor-element-715c49ac sc_layouts_hide_on_mobile sc_fly_static elementor-widget elementor-widget-spacer"
                    data-id="715c49ac"
                    data-element_type="widget"
                    data-widget_type="spacer.default"
                  >
                    <div className="elementor-widget-container">
                      <div className="elementor-spacer">
                        <div className="elementor-spacer-inner" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </footer>
  )
}
